import { ModuleWithProviders, NgModule } from '@angular/core';
import { AddCollectionToTabPopupService } from '../services/select-items/add-collection-to-tab-popup.service';
import { AddToCollectionPopupService } from '../services/select-items/add-to-collection-popup.service';
import { MoveCollectionWidgetToTabPopupService } from '../services/select-items/move-collection-widget-to-tab-popup.service';
import { MoveHeaderWidgetToTabPopupService } from '../services/select-items/move-header-widget-to-tab-popup.service';
import { MovePostWidgetToTabPopupService } from '../services/select-items/move-post-widget-to-tab-popup.service';


@NgModule()
export class MovingDataPopupHubModule {
  public static forRoot(): ModuleWithProviders<any>{
    return {
      ngModule: MovingDataPopupHubModule,
      providers: [
        MoveCollectionWidgetToTabPopupService,
        AddToCollectionPopupService,
        AddCollectionToTabPopupService,
        MoveHeaderWidgetToTabPopupService,
        MovePostWidgetToTabPopupService,
      ],
    };
  }
 }
